import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 1F3CFDCC-7391-4AA6-994C-DCC6F3D28A46
 * name moon-new
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/moon-new.svg
 * tags
 * - Weather 
 */
export const MoonNewIcon = createSvgIcon(<><path d="M12 20A8 8 0 1 1 20 12A8 8 0 0 1 12 20M12 2A10 10 0 1 0 22 12A10 10 0 0 0 12 2Z" /></>, 'MoonNewIcon');
export default MoonNewIcon